import Layout from "../Layout";
import { isEmpty, pick } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import ErrorMessage from "../../component/ErrorMessage";
import { isMobile } from "react-device-detect";
const ChangePassword = () => {
  const navigate = useNavigate();
  const preventMaxInput = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };

  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });

  const [showPassword, setShowPassword] = useState({
    first: false,
    second: false,
    third: false,
  });
  const handleShow = (id) => {
    setShowPassword({ ...showPassword, [id]: !showPassword[id] });
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm({});
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);
  const onSubmit = async (body) => {
    const obj = pick(body, ["oldPassword", "newPassword"]);
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        logoutUser();
        navigate("/");
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };
  return (
    <div className={isMobile ? "col col-12" : "col col-10 my-12"}>
      <div className="changePassword-wrapper">
        <div className="row hidden-md-and-up" style={{ height: "75px" }}>
          <div className="password-mobile-header text-center col col-12">
            Change password
          </div>
        </div>
        <div className="desktop_card v-card v-sheet theme--light">
          <div className="v-card__title hidden-sm-and-down">
            <label
              style={{ color: "black" }}
              className="--v-primary-base text-left text-capitalize"
            >
              Change password
            </label>
          </div>
          <div className="profile-detail-card v-card v-sheet theme--light elevation-0">
            <Form
              onSubmit={handleSubmit(onSubmit)}
              noValidate="novalidate"
              className="v-form"
            >
              <div className="row px-8 pt-4 no-gutters align-end">
                <div className="col-md-5 col-lg-4 col">
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block pb-1"
                          style={{ float: "left" }}
                        >
                          Current password
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2"></div>
                      <div className="col col-12">
                        <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  id="input-2653"
                                  placeholder="Fill up password here"
                                  type={
                                    showPassword?.first ? "text" : "password"
                                  }
                                  maxLength={20}
                                  minLength={6}
                                  onInput={(e) => preventMaxInput(e)}
                                  {...register("oldPassword", {
                                    required: "Please enter old password",
                                    validate: (value) => {
                                      if (value === "") {
                                        return true;
                                      }
                                      if (!!value.trim()) {
                                        return true;
                                      } else {
                                        return "White space are not allowed";
                                      }
                                    },
                                  })}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors?.oldPassword} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row px-8 no-gutters align-end">
                <div className="col-md-5 col-lg-4 col">
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block pb-1"
                          style={{ float: "left" }}
                        >
                          New password
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>

                      <div className="col col-12">
                        <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  id="input-2659"
                                  placeholder="Fill up password here"
                                  type={
                                    showPassword?.second ? "text" : "password"
                                  }
                                  maxLength={20}
                                  minLength={6}
                                  onInput={(e) => preventMaxInput(e)}
                                  {...register("newPassword", {
                                    required: "Please enter new password",
                                    validate: (value) => {
                                      if (value === "") {
                                        return true;
                                      }
                                      if (!!value.trim()) {
                                        return true;
                                      } else {
                                        return "White space are not allowed";
                                      }
                                    },
                                    //   pattern: {
                                    //     value: validationRules.password,
                                    //     message:
                                    //       "Password must contain lowercase,uppercase characters, numbers, special character and must be 6 character long.",
                                    //   },
                                  })}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors?.newPassword} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row px-8 no-gutters align-end">
                <div className="mb-4 col-md-5 col-lg-4 col">
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block pb-1"
                          style={{ float: "left" }}
                        >
                          Confirm new password
                          <span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2"></div>
                      <div className="col col-12">
                        <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  id="input-2663"
                                  placeholder="Fill up password here"
                                  type={
                                    showPassword?.third ? "text" : "password"
                                  }
                                  onInput={(e) => preventMaxInput(e)}
                                  maxLength={20}
                                  minLength={6}
                                  {...register("confirmPassword", {
                                    required: {
                                      value: true,
                                      message: "Please enter confirm password",
                                    },
                                    validate: (value) => {
                                      if (value === "") {
                                        return true;
                                      }
                                      if (!isEmpty(watch("newPassword"))) {
                                        if (value == watch("newPassword")) {
                                          return true;
                                        } else {
                                          return "password and confirm password does not match.";
                                        }
                                      }
                                    },
                                  })}
                                  onChange={(e) => {
                                    setValue(
                                      "confirmPassword",
                                      e.target.value,
                                      {
                                        shouldValidate: true,
                                      },
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <ErrorMessage errors={errors?.confirmPassword} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    data-v-1dea3caa
                    type="submit"
                    className="full-width font-weight-bold pa-2 dialog-button submit-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1"
                  >
                    <span style={{ color: "white" }} className="v-btn__content">
                      Submit
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
